<div class="product-lines">
    <h2 class="heading-2">{{ basketTitleText }}</h2>
    <template v-if="basketItems && basketItems.length > 0">
        <div  v-for="(item, index) in basketItems" >
            <div :class="{'product-line__totals': true, 'product-line__top-corner': index === 0 }">
                <div class="product-line__totals__label">{{ item.productDescription }}</div>
                <div class="product-line__totals__total flex flex-row items-center">
                    {{ formatCurrency(item.priceExclVat) }}

                    <Button
                        @click="removeItemFromBasket(item)"
                        severity="danger"
                        icon="pi pi-trash"
                        size="large"
                        style="padding:0;"
                        aria-label="verwijder uit winkelmandje"
                        text rounded
                    />
                </div>
            </div>
        </div>
        <div v-for="vatTotal in vatTotals" :key="vatTotal.vatPercentage">
            <div class="product-line__totals">
                <div class="product-line__totals__label">Btw {{ vatTotal.vatPercentage }}&percnt;</div>
                <div class="product-line__totals__total">{{ formatCurrency(vatTotal.vatAmount) }}</div>
            </div>
        </div>
        <div>
            <div class="product-line__totals product-line__sum product-line__bottom-corner">
                <div class="product-line__totals__label">Totaal</div>
                <div class="product-line__totals__total">{{ formatCurrency(totalAmountInclVat) }}</div>
            </div>
        </div>
    </template>
</div>
